import React from 'react';
import { WithStyles } from '@material-ui/core/styles';
import { Box } from '@material-ui/core';
import styles from './styles';
import FilterSelect from '../ActivationFilterSelect';
import CustomButton from '../CustomButton';

type FilterState = {
  activatedBy: string[];
  communityIds: string[];
  propertyIds: string[];
};

type Props = {
  communities: { id: number; name: string }[];
  properties: { id: number; address: string }[];
  activatedBy: string[];
  filters: FilterState;
  onFiltersChange: (filters: FilterState) => void;
} & WithStyles<typeof styles>;

export const ActivationFilter = (props: Props) => {
  const {
    classes,
    communities,
    properties,
    activatedBy,
    filters,
    onFiltersChange,
  } = props;

  return (
    <Box className={classes.filterContainer}>
      <FilterSelect
        label="Community"
        value={filters.communityIds}
        options={communities.map((c) => ({ label: c.name, value: c.id }))}
        onChange={(value) => onFiltersChange({ ...filters, communityIds: value })}
        multiple
      />
      <FilterSelect
        label="Property"
        value={filters.propertyIds}
        options={properties.map((p) => ({ label: p.address, value: p.id }))}
        onChange={(value) => onFiltersChange({ ...filters, propertyIds: value })}
        multiple
      />
      <FilterSelect
        label="Activated By"
        value={filters.activatedBy}
        options={activatedBy.map((a) => ({ label: a, value: a }))}
        onChange={(value) => onFiltersChange({ ...filters, activatedBy: value })}
        multiple
      />
      <CustomButton
        variant="orange"
        color="primary"
        onClick={() => onFiltersChange({
          activatedBy: [],
          communityIds: [],
          propertyIds: [],
        })}
      >
        Reset Filters
      </CustomButton>
    </Box>
  );
};
